export default {
  containers: {
    data: [],
    pagination: {
      total: 1,
      totalItems: 0,
      initialItem: 0
    }
  }
}
